/** Public SigmaSense support contact (app, legal pages, scripts). Not for customer/order phone fields. */
export const SUPPORT_EMAIL = 'support@sigmasense.pk'

/** Opens Gmail “Compose” in the browser with To: prefilled (merchants who use Gmail). */
export const SUPPORT_GMAIL_COMPOSE_URL = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(SUPPORT_EMAIL)}`
export const SUPPORT_PHONE_DISPLAY = '+92 311 1777502'
export const SUPPORT_PHONE_COMPACT = '+923111777502'
export const SUPPORT_PHONE_LOCAL = '0311 1777502'
export const SUPPORT_PHONE_TEL_HREF = 'tel:+923111777502'
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/923111777502'
